var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReachValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3569 6.00016L11.3569 1.3335L8.69027 1.3335L8.69027 5.95543C8.69027 7.42819 7.49636 8.6221 6.0236 8.6221C4.55084 8.6221 3.35693 7.42819 3.35693 5.95543L3.35693 1.3335L0.690267 1.3335L0.690267 6.00016C0.690267 8.94568 3.07808 11.3335 6.0236 11.3335C8.96912 11.3335 11.3569 8.94568 11.3569 6.00016Z",
    stroke: "#818291",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3569 4.02686L8.63191 4.02686M3.41529 4.02685L0.690268 4.02685",
    stroke: "#818291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachValue);
export default __webpack_public_path__ + "static/media/reach_value.17cee638be6e563d2df5b19bc6ed4099.svg";
export { ForwardRef as ReactComponent };